import api from '../../config/axios.js';

const state = {
    operatingHours: {
        opening_time: '',
        closing_time: ''
    },
    loadingOperatingHours: false,
    savingOperatingHours: false,
    operatingHoursError: null,
    whatsappInitialMessage: null,
    loadingWhatsappInitialMessage: false,
    savingWhatsappInitialMessage: false,
    whatsappInitialMessageError: null,
}

const getters = {
    getOperatingHours: state => state.operatingHours,
    getLoadingOperatingHours: state => state.loadingOperatingHours,
    getSavingOperatingHours: state => state.savingOperatingHours,
    getOperatingHoursError: state => state.operatingHoursError,
    getWhatsappInitialMessage: state => state.whatsappInitialMessage,
    getLoadingWhatsappInitialMessage: state => state.loadingWhatsappInitialMessage,
    getSavingWhatsappInitialMessage: state => state.savingWhatsappInitialMessage,
    getWhatsappInitialMessageError: state => state.whatsappInitialMessageError,
}

const actions = {
    // Buscar horários de funcionamento do backend
    async fetchOperatingHours({ commit }) {
        commit("setLoadingOperatingHours", true);
        commit("setOperatingHoursError", null);
        try {
            const response = await api.axios.get('/api/configuration/operating-hours');
            if (response && response.data) {
                commit("setOperatingHours", response.data);
            }
        } catch (error) {
            console.error('Erro ao buscar horários de funcionamento:', error);
            commit("setOperatingHoursError", 'Erro ao carregar horários de funcionamento');
        } finally {
            commit("setLoadingOperatingHours", false);
        }
    },

    // Salvar horários de funcionamento no backend
    async saveOperatingHours({ commit }, operatingHours) {
        commit("setSavingOperatingHours", true);
        commit("setOperatingHoursError", null);
        try {
            const response = await api.axios.post('/api/configuration/operating-hours', operatingHours);
            if (response && response.data) {
                commit("setOperatingHours", response.data);
            }
            return response.data;
        } catch (error) {
            console.error('Erro ao salvar horários de funcionamento:', error);
            const errorMessage = error.response?.data?.message || 'Erro ao salvar horários de funcionamento';
            commit("setOperatingHoursError", errorMessage);
            throw error;
        } finally {
            commit("setSavingOperatingHours", false);
        }
    },

    async fetchWhatsappInitialMessage({ commit }) {
        commit("setLoadingWhatsappInitialMessage", true);
        commit("setWhatsappInitialMessageError", null);
        try {
            const response = await api.axios.get('/api/whatsapp/initial-message');
            commit("setWhatsappInitialMessage", response.data);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Erro ao carregar a mensagem inicial';
            commit("setWhatsappInitialMessageError", errorMessage);
            throw error;
        } finally {
            commit("setLoadingWhatsappInitialMessage", false);
        }
    },

    async saveWhatsappInitialMessage({ commit }, configuration) {
        commit("setSavingWhatsappInitialMessage", true);
        commit("setWhatsappInitialMessageError", null);
        try {
            const payload = {
                presentation_text: configuration.presentation_text,
                notice_text: configuration.notice_text || null,
                attendant_emoji: configuration.attendant_emoji || null,
                option_emojis: configuration.options.map(option => ({
                    flow_id: option.id,
                    emoji: option.emoji || null,
                })),
            };
            const response = await api.axios.put('/api/whatsapp/initial-message', payload);
            commit("setWhatsappInitialMessage", response.data);
            return response.data;
        } catch (error) {
            const validationErrors = error.response?.data?.errors;
            const firstValidationError = validationErrors
                ? Object.values(validationErrors).flat()[0]
                : null;
            const errorMessage = firstValidationError
                || error.response?.data?.message
                || 'Erro ao salvar a mensagem inicial';
            commit("setWhatsappInitialMessageError", errorMessage);
            throw error;
        } finally {
            commit("setSavingWhatsappInitialMessage", false);
        }
    }
}

const mutations = {
    setOperatingHours: function(state, data) {
        state.operatingHours = data;
    },
    setLoadingOperatingHours: function(state, loading) {
        state.loadingOperatingHours = loading;
    },
    setSavingOperatingHours: function(state, saving) {
        state.savingOperatingHours = saving;
    },
    setOperatingHoursError: function(state, error) {
        state.operatingHoursError = error;
    },
    setWhatsappInitialMessage: function(state, data) {
        state.whatsappInitialMessage = data;
    },
    setLoadingWhatsappInitialMessage: function(state, loading) {
        state.loadingWhatsappInitialMessage = loading;
    },
    setSavingWhatsappInitialMessage: function(state, saving) {
        state.savingWhatsappInitialMessage = saving;
    },
    setWhatsappInitialMessageError: function(state, error) {
        state.whatsappInitialMessageError = error;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
